import CryptoJS from "crypto-js";
import { appInfo } from "../config/appInfo.const";

const SECRET_KEY = appInfo.localStorageEncryptionKey;
const DEFAULT_TTL_MINUTES = 24 * 60; // 1 day

// Encrypt data
export const encryptData = (data: any): string => {
  try {
    const json = JSON.stringify(data);
    return CryptoJS.AES.encrypt(json, SECRET_KEY).toString();
  } catch (e) {
    console.error("Encryption failed:", e);
    return "";
  }
};

// Decrypt data
export const decryptData = <T = any>(cipherText: string): T | null => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted ? JSON.parse(decrypted) as T : null;
  } catch (e) {
    console.error("Decryption failed:", e);
    return null;
  }
};

// Set with expiry (default 24 hours)
export const setSecureItem = (key: string, value: any, ttlMinutes: number = DEFAULT_TTL_MINUTES) => {
  const now = new Date().getTime();
  
  const dataToStore = {
    value,
    expiry: now + ttlMinutes * 60 * 1000 // convert min → ms
  };

  const encrypted = encryptData(dataToStore);
  localStorage.setItem(key, encrypted);
};

// Get and auto-expire
export const getSecureItem = <T = any>(key: string): T | null => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return null;

  const decrypted = decryptData<{ value: T, expiry: number }>(encrypted);
  if (!decrypted) return null;

  // Check expiry
  if (new Date().getTime() > decrypted.expiry) {
    localStorage.removeItem(key); // auto remove if expired
    return null;
  }

  return decrypted.value; // return real stored data
};

// Remove
export const removeSecureItem = (key: string) => {
  localStorage.removeItem(key);
};
